import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { Workshops } from './pages/Workshops';
import { WorkshopsInfo } from './pages/WorkshopsInfo';
import { WorkshopDetail } from './pages/WorkshopDetail';
import { Maekerscafes } from './pages/Maekerscafes';
import { Coffeebar } from './pages/Coffeebar';
import { LocationRental } from './pages/LocationRental';
import { ReservationRequest } from './pages/ReservationRequest';
import { FAQ } from './pages/FAQ';
import { AlgemeneVoorwaarden } from './pages/AlgemeneVoorwaarden';
import { Cadeaubonnen } from './pages/Cadeaubonnen';
import { Contact } from './pages/Contact';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { CookiePolicy } from './pages/CookiePolicy';
import { OverOns } from './pages/OverOns';
import { Verhalen } from './pages/Verhalen';
import { VerhaalDetail } from './pages/VerhaalDetail';
import { Team } from './pages/Team';
import { Vrijwilligers } from './pages/Vrijwilligers';
import { Lesgevers } from './pages/Lesgevers';
import { Femma } from './pages/Femma';
import { MaekerscafeDetail } from './pages/MaekerscafeDetail';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="flex flex-col min-h-screen bg-white" data-id="element-1">
        <Header data-id="element-2" />
        <main className="flex-1" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<Home data-id="element-6" />} data-id="element-5" />
            <Route path="/workshops" element={<Workshops data-id="element-8" />} data-id="element-7" />
            <Route path="/workshop-info" element={<WorkshopsInfo data-id="element-10" />} data-id="element-9" />
            <Route path="/workshops/:id" element={<WorkshopDetail data-id="element-12" />} data-id="element-11" />
            <Route path="/maekerscafés" element={<Maekerscafes data-id="element-14" />} data-id="element-13" />
            <Route path="/maekerscafés/:slug" element={<MaekerscafeDetail data-id="element-16" />} data-id="element-15" />
            <Route path="/koffiebar" element={<Coffeebar data-id="element-18" />} data-id="element-17" />
            <Route path="/locatie-huren" element={<LocationRental data-id="element-20" />} data-id="element-19" />
            <Route path="/locatie-huren/aanvraag" element={<ReservationRequest data-id="element-22" />} data-id="element-21" />
            <Route path="/faq" element={<FAQ data-id="element-24" />} data-id="element-23" />
            <Route path="/algemene-voorwaarden" element={<AlgemeneVoorwaarden data-id="element-26" />} data-id="element-25" />
            <Route path="/cadeaubonnen" element={<Cadeaubonnen data-id="element-28" />} data-id="element-27" />
            <Route path="/contact" element={<Contact data-id="element-30" />} data-id="element-29" />
            <Route path="/privacybeleid" element={<PrivacyPolicy data-id="element-32" />} data-id="element-31" />
            <Route path="/cookiebeleid" element={<CookiePolicy data-id="element-34" />} data-id="element-33" />
            <Route path="/over-ons" element={<OverOns data-id="element-36" />} data-id="element-35" />
            <Route path="/team" element={<Team data-id="element-38" />} data-id="element-37" />
            <Route path="/vrijwilligers" element={<Vrijwilligers data-id="element-40" />} data-id="element-39" />
            <Route path="/lesgevers" element={<Lesgevers data-id="element-42" />} data-id="element-41" />
            <Route path="/femma" element={<Femma data-id="element-44" />} data-id="element-43" />
            <Route path="/verhalen" element={<Verhalen data-id="element-46" />} data-id="element-45" />
            <Route path="/verhalen/:slug" element={<VerhaalDetail data-id="element-48" />} data-id="element-47" />
          </Routes>
        </main>
        <Footer data-id="element-49" />
      </div>
    </BrowserRouter>;
}